export const abbreviationDynamicTextStyles = {
  textStyles: { padding: '5px' },
  wrapperStyles: { borderRadius: '5px', maxWidth: '100px', minWidth: '100px' },
  inputStyles: { fontSize: '13px' },
}
